import { createTheme } from '@mui/material/styles';

// プロジェクト全体で使用する統一カラーパレット
const theme = createTheme({
  palette: {
    primary: {
      main: '#111111', // 黒
      light: '#424242', // 明るいグレー（ダークグレー）
      dark: '#000000', // より暗い黒
      contrastText: '#ffffff', // 白テキスト
    },

    secondary: {
      main: '#2cf433', // ログインページで使用されている緑色をベースに
      light: '#5ff666', // 明るい緑
      dark: '#1fb324', // 暗い緑
      contrastText: '#ffffff', // 白いテキスト
    },
    error: {
      main: '#d32f2f', // エラー用の赤
      light: '#ef5350',
      dark: '#c62828',
    },
    warning: {
      main: '#ed6c02', // 警告用のオレンジ
      light: '#ff9800',
      dark: '#e65100',
    },
    info: {
      main: '#0288d1', // 情報用の青
      light: '#03a9f4',
      dark: '#01579b',
    },
    success: {
      main: '#2e7d32', // 成功用の緑
      light: '#4caf50',
      dark: '#1b5e20',
    },
    background: {
      default: '#f5f5f5', // デフォルト背景色
      paper: '#ffffff', // ペーパー背景色
    },
    text: {
      primary: '#212121', // メインテキスト色
      secondary: '#757575', // セカンダリテキスト色
    },
  },
  typography: {
    fontFamily: [
      '"Noto Sans JP"',
      '"Roboto"',
      '"Helvetica"',
      '"Arial"',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8, // 統一された角丸の設定
  },
  components: {
    // Buttonコンポーネントのデフォルト設定
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 25, // ログインページで使用されている角丸設定
          textTransform: 'none', // 大文字変換を無効化
          fontWeight: 500,
          // ホバー時の色設定
          '&:hover': {
            backgroundColor: '#696969',
            color: '#ffffff',
            border: '1px solid #696969',
          },
        },
      },
    },
    // TextFieldコンポーネントのデフォルト設定
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    // Paperコンポーネントのデフォルト設定
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
